import useNumber from './useCounter';
export default useNumber;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useNumber.js
// module id = v/Ht
// module chunks = 0